import React from "react";

function AboutUs() {
    return (
        <div className="max-w-4xl mx-auto p-6 bg-white rounded shadow">
            <h1 className="text-3xl font-bold mb-4">About Us</h1>
            <p className="mb-4">
                Welcome to <strong>ShopEase</strong>, your trusted destination for
                shopping smart and living better. Founded in 2020, our mission has
                always been simple: to provide high-quality products at affordable
                prices, backed by exceptional customer service.
            </p>
            <p className="mb-4">
                We started as a small team of passionate entrepreneurs who believed
                online shopping should be easy, safe, and enjoyable. Today, we are proud
                to serve thousands of customers across the globe, offering everything
                from fashion and electronics to home essentials and lifestyle products.
            </p>
            <h2 className="text-xl font-semibold mt-6 mb-2">Our Mission</h2>
            <p className="mb-4">
                To empower customers with the best shopping experience by offering a
                wide range of quality products, transparent policies, and fast,
                reliable delivery.
            </p>
            <h2 className="text-xl font-semibold mt-6 mb-2">Our Values</h2>
            <ul className="list-disc pl-6 mb-4 space-y-2">
                <li><strong>Customer First</strong>: Your satisfaction is our priority.</li>
                <li><strong>Integrity</strong>: We believe in honest practices and transparency.</li>
                <li><strong>Innovation</strong>: Constantly improving to serve you better.</li>
                <li><strong>Sustainability</strong>: Committed to eco-friendly operations.</li>
            </ul>
            <p>
                Thank you for choosing ShopEase. We look forward to being part of your
                shopping journey for years to come.
            </p>
        </div>
    );
}

export default AboutUs;
